// extracted by mini-css-extract-plugin
export var borderRadius = "_dq-4";
export var large = "_dq-3";
export var logoContainer = "_dq-0";
export var nameLogo = "_dq-2";
export var small = "_dq-1";